/* External */
import {
  useMemo, memo, useRef, useCallback, useEffect,
} from 'react';
import PropTypes from 'prop-types';

/* Components */
import ScrollIntoViewIfFocused from '../ScrollIntoViewIfFocused';

/* Utils */
import { ScrollPosition } from '../ScrollView';

function CardCarousel({
  focusKey,
  children,
  width,
  onWidthChange,
}) {
  const ref = useRef(undefined);
  const lastWidth = useRef(undefined);

  const style = useMemo(() => (width ? ({
    width: `${width}rem`,
    flex: `0 0 ${width}rem`,
  }) : ({})), [width]);

  const updateWidth = useCallback(() => {
    if (ref.current && onWidthChange && lastWidth.current !== ref.current.clientWidth) {
      lastWidth.current = ref.current.clientWidth;
      onWidthChange(lastWidth.current);
    }
  }, [onWidthChange]);

  const assignRef = useCallback((value) => {
    ref.current = value;
    updateWidth();
  }, [updateWidth]);

  useEffect(() => {
    updateWidth();
  });

  return (
    <ScrollIntoViewIfFocused
      focusKey={focusKey}
      className="dtv-html5-c-carousel__card"
      style={style}
      position={ScrollPosition.CENTER}
      assignRef={assignRef}
    >
      {children}
    </ScrollIntoViewIfFocused>
  );
}

CardCarousel.propTypes = {
  focusKey: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  width: PropTypes.number,
  onWidthChange: PropTypes.func,
};

CardCarousel.defaultProps = {
  width: undefined,
  onWidthChange: undefined,
};

export default memo(CardCarousel);
